module.exports = __webpack_public_path__ + "e9b2ab9642f303eda6a03dd9d4ddd463.svg";


//////////////////
// WEBPACK FOOTER
// ./images/badge-siempreplus.svg
// module id = TLue
// module chunks = 0